import { Box } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

export const PreparedForContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 3rem;
  gap: 0.25rem;
  p {
    font-size: ${(p) => p.theme.text.fontSizes.l};
  }
`;

export const CoverPhotoContainer = styled(Box)`
  max-height: 380px;
  aspect-ratio: 16/9;
  width: 100%;
  border-radius: 0.5rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(p) => p.theme.colors.background2};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.5rem;
  }
`;

export const CoverPhotoContainerView = styled(CoverPhotoContainer)`
  max-height: 60dvh;
`;

export const AddCoverPhotoContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 360px;
  max-height: 360px;
  width: 100%;
  background-color: ${(p) => p.theme.colors.background2};
`;
